<mat-toolbar
  [ngStyle]="{
    'background-color': 'white',
    'border-bottom': '1px solid var(--theme-primary-500,  #6599ca)'
  }"
  fxLayout="row"
  fxLayoutAlign="none">
  <span class="logo cursor-mat-element" fxLayout="column" fxLayoutAlign="center center">
    <img
      aria-label="Logo des Stadtwerks"
      tabindex="0"
      style="height: 38px"
      [src]="(dataShareService.currentTenant$ | async)?.theme?.logoUrl" />
  </span>

  <span fxFlex fxLayout="row" fxLayoutAlign="end none">
    <button mat-raised-button color="primary" *ngIf="!buildIsUpToDate" (click)="reload()">
      neuere Version verfügbar - Jetzt neu laden
    </button>

    <button
      class="login-button"
      (click)="login()"
      *ngIf="!(authenticationService.isLoggedIn$ | async) && !hideLoginMenu"
      mat-button>
      Anmelden
      <mat-icon iconPositionEnd>login</mat-icon>
    </button>

    <span class="user-menu" *ngIf="(authenticationService.isLoggedIn$ | async) && !hideLoginMenu">
      <button fxFlex mat-button [matMenuTriggerFor]="user">
        <mat-icon>account_circle</mat-icon>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #user="matMenu">
        <app-view-menu
          (clickedItem)="clickOnMenu($event)"
          [menu]="userMenu"
          [disableTooltips]="true"
          fxFlex></app-view-menu>
      </mat-menu>
    </span>
  </span>
</mat-toolbar>

<div *ngIf="dataShareService.isLoading$ | async">
  <mat-progress-bar mode="indeterminate" class="loading-bar"></mat-progress-bar>
</div>
